var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChestFilled = function SvgChestFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6966A4",
    fillRule: "evenodd",
    d: "M5.334 15.922C5.334 9.337 10.672 4 17.256 4h29.49c6.584 0 11.921 5.337 11.921 11.922v6.43a2.98 2.98 0 0 1-2.98 2.981H40.245a4.413 4.413 0 0 0-7.15-4.914L32 21.514l-1.094-1.095a4.411 4.411 0 0 0-7.15 4.914H8.314a2.98 2.98 0 0 1-2.98-2.98zm18.588 13.914H11.295a5.96 5.96 0 0 0-5.961 5.96V51.17a8 8 0 0 0 8 8h37.333a8 8 0 0 0 8-8V35.797a5.96 5.96 0 0 0-5.96-5.96H40.078a4.413 4.413 0 0 1-6.984 5.248L32 33.99l-1.094 1.095a4.411 4.411 0 0 1-6.984-5.249",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6966A4",
    fillRule: "evenodd",
    d: "M26.586 22.336a2 2 0 0 1 2.828 0L32 24.922l2.586-2.586a2 2 0 1 1 2.828 2.828l-2.586 2.586 2.586 2.586a2 2 0 1 1-2.828 2.828L32 30.578l-2.586 2.586a2 2 0 1 1-2.828-2.828l2.586-2.586-2.586-2.586a2 2 0 0 1 0-2.828",
    clipRule: "evenodd"
  })));
};
export default SvgChestFilled;